// Ported from eb-ui `src/legacy/components/AutocreatedPill/AutocreatedPill.tsx`
// (+ `.styles.ts`).
//   - `@emotion/styled` (no Valkyrie home) → plain CSS classes
//     (`cc-autocreated-pill*`, see `src/styles/cc/autocreated-pill.scss`).
//   - `@eventbrite/legacy-infra.http` `setWindowLocation` →
//     `window.location.assign`.
//   - `@eventbrite/legacy-eds.icon` / `.illustration` / iconography → the local
//     `../lib/iconography` (ArrowRightChunky + CloudAbstract are not in the
//     142-icon bridge subset).
// The copy (gettext), CTA behaviour (trackEvent + navigate) and layout (fixed
// top-right ≥768px, #1e0a3c) are preserved verbatim.
import React from 'react';

import { AnalyticsAction, AnalyticsCategory, trackEvent } from '../../_shared';
import { getDefaultAutocreatedCollectionPillTitle } from '../../_shared/constants';
import { Icon } from '../../lib/iconography';
import { ArrowRightChunky, CloudAbstract } from '../../lib/iconography';
import { gettext } from '@/lib/gettext';

export const LABEL_EDIT = 'Edit';

export const PUBLISHING_STEPS = [
    gettext("Update your collection's name, description, and image").toString(),
    gettext('Add or remove events').toString(),
    gettext('Publish and share with the world').toString(),
];

export interface Props {
    collectionId: string;
}

export const AutocreatedPill: React.FC<Props> = ({ collectionId }) => (
    <div className="cc-autocreated-pill">
        <div className="cc-autocreated-pill__background" aria-hidden="true">
            <CloudAbstract width="100%" height="100%" />
        </div>
        <h2 className="cc-autocreated-pill__title">
            {getDefaultAutocreatedCollectionPillTitle()}
        </h2>
        <ol className="cc-autocreated-pill__steps">
            {PUBLISHING_STEPS.map((text, index) => (
                <li
                    key={`autocreated-publishing-step-${index}`}
                    className="cc-autocreated-pill__step"
                >
                    <span className="cc-autocreated-pill__step-counter">
                        {index + 1}
                    </span>
                    {text}
                </li>
            ))}
        </ol>
        <div
            className="cc-autocreated-pill__finish"
            role="button"
            tabIndex={0}
            onClick={() => {
                trackEvent({
                    action: AnalyticsAction.AutoCollectionInitiate,
                    category: AnalyticsCategory.Collections,
                    label: LABEL_EDIT,
                });
                window.location.assign(
                    `/manage/collections/${collectionId}/events`,
                );
            }}
        >
            {gettext('Finish editing collection').toString()}
            <span className="cc-autocreated-pill__arrow">
                <Icon color="white" size="xsmall" type={<ArrowRightChunky />} />
            </span>
        </div>
    </div>
);
